import { UseToast } from '../../../../../lib/chakraUi/hooks';
import { getErrorToastDescription } from './getErrorToastDescription';

export const launchErrorToast = (
  registerToast: UseToast,
  error: any,
  idempotencyKey: string,
) => {
  registerToast({
    type: 'error',
    title: 'Error',
    description: getErrorToastDescription(error),
    id: `requestError-${idempotencyKey}`,
  });
};
